/**
 * Normalizes a document row from tenant/workspace APIs for Knowledge UI.
 *
 * @param {Record<string, unknown>} doc
 * @returns {Record<string, unknown>}
 */
export const normalizeVaultDocument = (doc) => {
  if (!doc || typeof doc !== 'object') return doc;
  const fileName = typeof doc.name === 'string' ? doc.name : '';
  const extractedExtension =
    typeof doc.extension === 'string'
      ? doc.extension
      : fileName.includes('.')
        ? fileName.split('.').pop().toLowerCase()
        : null;

  const getTypeFromExtension = (ext) => {
    if (!ext) return null;
    const extLower = ext.toLowerCase();
    if (['pdf'].includes(extLower)) return 'application/pdf';
    if (['doc', 'docx'].includes(extLower)) return 'application/msword';
    if (['xls', 'xlsx'].includes(extLower)) return 'application/vnd.ms-excel';
    if (['ppt', 'pptx'].includes(extLower)) return 'application/vnd.ms-powerpoint';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(extLower)) return 'image';
    return null;
  };

  return {
    ...doc,
    uuid: doc.documentUuid ?? doc.uuid ?? doc.id,
    id: doc.documentUuid ?? doc.uuid ?? doc.id,
    created_at: doc.createdAt ?? doc.created_at,
    createdAt: doc.createdAt ?? doc.created_at,
    updated_at: doc.updatedAt ?? doc.updated_at,
    updatedAt: doc.updatedAt ?? doc.updated_at,
    owner:
      doc.ownerFullName ??
      doc.owner ??
      doc.createdBy ??
      doc.uploadedBy ??
      'Unknown',
    createdBy:
      doc.ownerFullName ??
      doc.owner ??
      doc.createdBy ??
      doc.uploadedBy ??
      'Unknown',
    state: doc.status ?? doc.state ?? null,
    name: typeof doc.name === 'string' ? doc.name : 'Unnamed Document',
    description: doc.description ?? null,
    type: doc.type ?? getTypeFromExtension(extractedExtension),
    extension: extractedExtension,
    size: doc.size ?? null,
    metadata: doc.metadata && typeof doc.metadata === 'object' ? doc.metadata : {},
  };
};
